import React, {Component} from 'react';
import {Card, CardBody, Col, CardHeader, Row} from "reactstrap";

import '../css/sponsors.css';
import '../css/wgteam.css';

class WebGradeTeamComponent extends Component{

    render(props){
        return (
            <div className='col-md-10 offset-1'>
                <br/>
                <h3 className='subtitle'> WebGrade tim </h3>
                <br/>
                <Row>
                    <div className='col-lg-3 col-md-6'>
                        <Card className="card-coin card-plain card-wgteam">
                            <CardHeader>
                                <img alt="..." className="img-center img-fluid rounded-circle" src={'../src/assets/akocic.jpg'}/>
                                <h4 className="title">Aleksandra Kocić</h4>
                                <h5 className="subtitle"> Autor sistema </h5>
                            </CardHeader>
                            <CardBody>
                                Osnovne i master studije završila je na Matematičkom fakultetu. Trenutno je student doktorskih studija
                                i asistent na Katedri za računarstvo i informatiku. Jedan je od autora zbirke zadataka sa rešenjima za predmet Programiranje 1
                                u izdanju Matematičkog fakulteta.
                                Idejni je tvorac platforme WebGrade. Vodi razvoj veb platforme od 2015. godine.
                                <br/>
                                <Row className={'wgteam-contact'}>
                                    <hr className='redDivider'/>
                                    <Col sm={3}><a href={'https://www.linkedin.com/in/aleksandra290709/'} target={'_blank'}> <span className={'fa fa-linkedin fa-2x'}></span> </a></Col>
                                    <Col sm={3}><a href={'mailto:aleksandra_kocic@matf.bg.ac.rs'} target={'_blank'}> <span className={'fa fa-envelope fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'http://poincare.matf.bg.ac.rs/~asimic/'} target={'_blank'}> <span className={'fa fa-globe fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'https://www.facebook.com/webgrade.matf/'} target={'_blank'}> <span className={'fa fa-facebook fa-2x'}></span></a></Col>
                                    <hr className='redDivider'/>
                                </Row>
                            </CardBody>
                        </Card>
                    </div>
                    <div className='col-lg-3 col-md-6'>
                        <Card className="card-coin card-plain card-wgteam">
                            <CardHeader>
                                <img alt="..." className="img-center img-fluid rounded-circle" src={'../src/assets/okocic.jpeg'}/>
                                <h4 className="title">Ognjen Kocić</h4>
                                <h5 className="subtitle"> Autor sistema </h5>
                            </CardHeader>
                            <CardBody>
                                Osnovne i master studije završio je na Matematičkom fakultetu. Trenutno je student doktorskih studija
                                i asistent na Katedri za računarstvo i informatiku. U sklopu svog istraživačkog rada se bavi mašinskim učenjem
                                i obradom slika. Autor je sistema WebGrade. Vodi razvoj ocenjivača od 2015. godine.
                                <br/>

                                <Row className={'wgteam-contact'}>
                                    <hr className='redDivider'/>
                                    <Col sm={3}><a href={'https://www.linkedin.com/in/ognjen-koci%C4%87-b809958b/'} target={'_blank'}> <span className={'fa fa-linkedin fa-2x'}></span> </a></Col>
                                    <Col sm={3}><a href={'mailto:ognjen@matf.bg.ac.rs'} target={'_blank'}> <span className={'fa fa-envelope fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'http://poincare.matf.bg.ac.rs/~ognjen/'} target={'_blank'}> <span className={'fa fa-globe fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'https://www.facebook.com/webgrade.matf/'} target={'_blank'}> <span className={'fa fa-facebook fa-2x'}></span></a></Col>
                                    <hr className='redDivider'/>
                                </Row>
                            </CardBody>
                        </Card>
                    </div>
                    <div className='col-lg-3 col-md-6'>
                        <Card className="card-coin card-plain card-wgteam">
                            <CardHeader>
                                <img alt="..." className="img-center img-fluid rounded-circle" src={'../src/assets/vnovakovic.jpg'}/>
                                <h4 className="title">Vuk Novaković</h4>
                                <h5 className="subtitle"> Programer </h5>
                            </CardHeader>
                            <CardBody>
                                Trenutno je student završne godine osnovnih studija na smeru Informatika. Član je organizacionog tima
                                studentske organizacije RISK.
                                Učestvuje u razvoju sistema od juna 2018. godine.
                                <br/>
                                <Row className={'wgteam-contact'}>
                                    <hr className='redDivider'/>
                                    <Col sm={3}><a href={'https://www.linkedin.com/in/vuk-novakovic/'} target={'_blank'}> <span className={'fa fa-linkedin fa-2x'}></span> </a></Col>
                                    <Col sm={3}><a href={'mailto:vnovakovic96@gmail.com'} target={'_blank'}> <span className={'fa fa-envelope fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'http://alas.math.rs/~mr15334/cv_english.pdf'} target={'_blank'}> <span className={'fa fa-globe fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'https://github.com/wdtbd'} target={'_blank'}> <span className={'fa fa-github fa-2x'}></span></a></Col>
                                    <hr className='redDivider'/>
                                </Row>
                            </CardBody>
                        </Card>
                    </div>
                    <div className='col-lg-3 col-md-6'>
                        <Card className="card-coin card-plain card-wgteam">
                            <CardHeader>
                                <img alt="..." className="img-center img-fluid rounded-circle" src={'../src/assets/ptrifunov.jpeg'}/>
                                <h4 className="title">Peđa Trifunov</h4>
                                <h5 className="subtitle"> Programer</h5>
                            </CardHeader>
                            <CardBody>
                                Trenutno je student završne godine osnovnih studija na smeru Informatika. Član je organizacionog tima
                                studentske organizacije RISK.
                                Radio je na sistemu u toku leta 2018. godine.
                                <br/>
                                <Row className={'wgteam-contact'}>
                                    <hr className='redDivider'/>
                                    <Col sm={3}><a href={'https://www.linkedin.com/in/pedja-trifunov/'} target={'_blank'}> <span className={'fa fa-linkedin fa-2x'}></span> </a></Col>
                                    <Col sm={3}><a href={'mailto:trifunov.pedja@gmail.com'} target={'_blank'}> <span className={'fa fa-envelope fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'https://www.linkedin.com/in/pedja-trifunov/'} target={'_blank'}> <span className={'fa fa-globe fa-2x'}></span></a></Col>
                                    <Col sm={3}><a href={'https://github.com/atfoc'} target={'_blank'}> <span className={'fa fa-github fa-2x'}></span></a></Col>
                                    <hr className='redDivider'/>
                                </Row>

                            </CardBody>
                        </Card>
                    </div>
                </Row>
                <br/>
            </div>
        );
    }
}

export default WebGradeTeamComponent;